let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gKXx1")).then(() => parcelRequire('4KX56'));